import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Release\CreateReleaseController::__invoke
* @see app/Http/Controllers/Release/CreateReleaseController.php
* @route '/api/sa-management/release'
*/
const CreateReleaseController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateReleaseController.url(options),
    method: 'post',
})

CreateReleaseController.definition = {
    methods: ["post"],
    url: '/api/sa-management/release',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Release\CreateReleaseController::__invoke
* @see app/Http/Controllers/Release/CreateReleaseController.php
* @route '/api/sa-management/release'
*/
CreateReleaseController.url = (options?: RouteQueryOptions) => {
    return CreateReleaseController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Release\CreateReleaseController::__invoke
* @see app/Http/Controllers/Release/CreateReleaseController.php
* @route '/api/sa-management/release'
*/
CreateReleaseController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateReleaseController.url(options),
    method: 'post',
})

export default CreateReleaseController